import { isRequiredRule } from '../Validation/rules';
export const selectInputRuleSet = [isRequiredRule];